import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import { tsfStatus } from "@/data/tsf_status";
import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7FIATimeSerieFilesSchema = z.object({
  date_equals: z.string().optional(),
  status_equals: z.string().optional(),
  fund_name_contains: z.string().optional(),
  error_message_contains: z.string().optional(),
});

export type FilterA7FIATimeSerieFilesSchema = z.infer<
  typeof filterA7FIATimeSerieFilesSchema
>;

export function FilterA7FIATimeSerieFiles({
  table_name,
  client,
}: {
  table_name: string;
  client: string;
}) {
  const { t, i18n } = useTranslation();
  const initialFields: Field[] = useMemo(
    () => [
      {
        name: "date_equals",
        label: t("a7_fia_time_serie_files.columns.date", {
          ns: "tables",
          defaultValue: "Date",
        }),
        type: "autocomplete",
        options: [],
      },
      {
        name: "status_equals",
        label: t("a7_fia_time_serie_files.columns.status", {
          ns: "tables",
          defaultValue: "Statut",
        }),
        type: "autocomplete",
        options: tsfStatus,
      },
      {
        name: "fund_name_contains",
        label: t("a7_fia_time_serie_files.columns.fund_name", {
          ns: "tables",
          defaultValue: "Fonds",
        }),
        type: "input",
      },
      {
        name: "error_message_contains",
        label: t("a7_fia_time_serie_files.columns.error_message", {
          ns: "tables",
          defaultValue: "Message d'erreur",
        }),
        type: "input",
      },
    ],
    [i18n.language, t],
  );
  const { fields } = useDateOptions(client, table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7FIATimeSerieFilesSchema}
      client={client}
      tableName="a7_fia_time_serie_files"
      fields={fields}
      excludeFieldsFromConvertDate={["date_equals"]}
      customBuildPath={() => `a7-fia/${table_name}`}
    />
  );
}
